import { BatchPreviewAssignPage } from "../batch-preview-assign-page";
import { BatchPreviewTable } from "../batch-preview-table";

import { useBatchPreviewInterventionAssignPage } from "./batch-preview-intervention-assign-page.hook";

export const BatchPreviewInterventionAssignPage = () => {
  const { interventions, loading, columns } =
    useBatchPreviewInterventionAssignPage();

  return (
    <BatchPreviewAssignPage model="intervention">
      <BatchPreviewTable
        model="intervention"
        items={interventions}
        loading={loading}
        columns={columns}
      />
    </BatchPreviewAssignPage>
  );
};
